Buyapowa.Controllers.ReferralStatus = class ReferralStatus {
  constructor(el) {
    this.el = el;
    this.view = new Buyapowa.Views.ReferralStatus(this.el);
  }
};
